import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-loader-grow',
  templateUrl: './loader-grow.component.html',
  styleUrls: ['./loader-grow.component.scss']
})
export class LoaderGrowComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
